import { VerificationAddressGetKycDocumentsQuery } from '../graphql/queries/get-kyc-documents.gql';
import {
  AccommodationStatus,
  ADDRESS_DOCUMENT_TYPES,
  SELF_HOSTED_DOCUMENT_TYPE,
} from './constants';

type KycDocumentsQueryData = Pick<
  VerificationAddressGetKycDocumentsQuery['viewer']['companyUser'],
  'kycDocuments'
>;

/**
 * A function which returns if the user is self hosted or hosted
 * based on the kyc documents query data.
 *
 * It returns null if the user hasn't uploaded any address document yet
 */
export const getAccommodationStatus = ({
  kycDocuments,
}: KycDocumentsQueryData): AccommodationStatus | null => {
  const addressDocuments = kycDocuments.filter(({ type }) =>
    ADDRESS_DOCUMENT_TYPES.includes(type),
  );

  if (!addressDocuments || addressDocuments.length === 0) {
    return null;
  }

  return addressDocuments.some((doc) => doc?.type === SELF_HOSTED_DOCUMENT_TYPE)
    ? AccommodationStatus.SELF_HOSTED
    : AccommodationStatus.HOSTED;
};
